module.exports = __webpack_public_path__ + "media/images/emblems/Bournens-coat_of_arms-a70aed5c5e221c587aabddc09d1a5142.svg";